import { render } from "./PromoBox.vue?vue&type=template&id=5475113f&scoped=true"
import script from "./PromoBox.vue?vue&type=script&lang=js"
export * from "./PromoBox.vue?vue&type=script&lang=js"

import "./PromoBox.vue?vue&type=style&index=0&id=5475113f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5475113f"]])

export default __exports__